import {
	CHANGE_NEW_SOL_FORM_SETTINGS,
	CHANGE_NEW_SOLICITOR_PROPERTIES,
	RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR,
	RECEIVE_BAD_RESPONSE_POST_NEW_SOLICITOR,
	RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE,
	RECEIVE_POST_NEW_SOLICITOR_RESPONSE,
	REQUEST_NEW_SOLICITOR,
	REQUEST_PATCH_EXISTING_SOLICITOR,
	SOLICITOR_FORM_EMAIL_INFO,
	SOLICITOR_FORM_EMAIL_VALIDATION_ERROR,
	SOLICITOR_FORM_USERNAME_INFO,
	SOLICITOR_FORM_USERNAME_VALIDATION_ERROR,
	NEW_SOLICITOR_UPDATE_LAWSYS_FIELD,
	REQUEST_GET_SELECTED_SOLICITOR_USER,
	RECEIVE_GET_SELECTED_SOLICITOR_USER,
	RECEIVE_BAD_REQUEST_GET_SELECTED_SOLICITOR_USER,
	REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
	RECEIVE_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
	RECEIVE_BAD_REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
	UNLOCK_SOLICITOR_USER,
	UNLOCK_SOLICITOR_USER_SUCCESS,
	UNLOCK_SOLICITOR_USER_FAILED,
	CHANGE_SOLICITOR_USER_ADVANCE_DISBURSEMENTS,
} from "./index";
import {actionCreator} from "../helpers/functions";

export const unlockSolicitorUser = actionCreator(UNLOCK_SOLICITOR_USER);
export const unlockSolicitorUserSuccess = actionCreator(UNLOCK_SOLICITOR_USER_SUCCESS);
export const unlockSolicitorUserFailed = actionCreator(UNLOCK_SOLICITOR_USER_FAILED);

//action that displays the email info in the create new solicitorForm component
export function solicitorFormEmailInfo() {
	return {
		type: SOLICITOR_FORM_EMAIL_INFO
	}
}

//action that displays the username input field info in the create new solicitorForm component
export function solicitorFormUsernameInfo() {
	return {
		type: SOLICITOR_FORM_USERNAME_INFO
	}
}

//action that displays email validation error when the email is not unique and valid
export function solicitorFormEmailValidationError() {
	return {
		type: SOLICITOR_FORM_EMAIL_VALIDATION_ERROR
	}
}

//action tha displays username validation error when the username is not unique and valid
export function solicitorFormUsernameValidationError() {
	return {
		type: SOLICITOR_FORM_USERNAME_VALIDATION_ERROR
	}
}

//action that changes the redux stored values of the login form
export function changeNewSolicitorProperties(property, data) {
	return {
		type: CHANGE_NEW_SOLICITOR_PROPERTIES,
		payload: {
			key: property,
			value: data
		}
	}
}
//action that changes the redux stored values of the login form
export function changeNewSolicitorLawsysField(payload) {
	return {
		type: NEW_SOLICITOR_UPDATE_LAWSYS_FIELD,
		payload
	}
}

//action that requests POST new Solicitor
export function requestNewSolicitor(newSolicitor, token) {
	return {
		type: REQUEST_NEW_SOLICITOR,
		payload: {
			solicitor: newSolicitor,
			userToken: token
		}
	}
}

//action that updated the redux store with the new posted solicitor after successful response
export function receivePostNewSolicitorResponse(repsonse) {
	return {
		type: RECEIVE_POST_NEW_SOLICITOR_RESPONSE,
		payload: repsonse
	}
}

//action that receives bad request response from posting new solicitor
export function receiveBadResponsePostNewSolicitor(repsonse) {
	return {
		type: RECEIVE_BAD_RESPONSE_POST_NEW_SOLICITOR,
		payload: repsonse
	}
}

//action that changed redux settings
export function changeNewSolFormSettings(key, value) {
	return {
		type: CHANGE_NEW_SOL_FORM_SETTINGS,
		payload: {
			key: key,
			value: value
		}
	}
}


export function requestPatchExistingSolicitor(newSolicitor, id) {
	return {
		type: REQUEST_PATCH_EXISTING_SOLICITOR,
		payload: {newSolicitor, id}
	}
}

export function receivePatchExistingSolicitorResponse(repsonse) {
	return {
		type: RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE,
		payload: repsonse
	}
}

export function receiveBadRequestPatchExistingSolicitor(repsonse) {
	return {
		type: RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR,
		payload: repsonse
	}
}


//action that request get selected solicitor
export function requestGetSelectedSolicitorUser(solicitorId) {
	return {
		type: REQUEST_GET_SELECTED_SOLICITOR_USER,
		payload:solicitorId
	}
}

//action that receives get selected solicitor
export function receiveGetSelectedSolicitorUser(solicitorUser) {
	return {
		type: RECEIVE_GET_SELECTED_SOLICITOR_USER,
		payload: solicitorUser
	}
}

//action that receives bad request get selected solicitor
export function receiveBadRequestGetSelectedSolicitorUser(response) {
	return {
		type: RECEIVE_BAD_REQUEST_GET_SELECTED_SOLICITOR_USER,
		payload: response
	}
}

//action to make the api send an email to a solicitor user for password reseting
export function requestSendResetPasswordEmailToSolicitor(payload) {
	return {
		type: REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
		payload
	}
}

export function receiveSendResetPasswordEmailToSolicitor(payload) {
	return {
		type: RECEIVE_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
		payload
	}
}

export function receiveBadRequestSendResetPasswordEmailToSolicitor(payload) {
	return {
		type: RECEIVE_BAD_REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
		payload
	}
}


export function changeSolicitorUserCaseAndSubCasesTypes(payload){
	return {
		type:CHANGE_SOLICITOR_USER_ADVANCE_DISBURSEMENTS,
		payload
	}
};



